/* eslint-disable no-prototype-builtins */
import Reflux from "reflux";
import logger from "../../utils/LoggerFrontend";
import { ActionsGlobalMediaLibrary } from "../../Actions/ActionsGlobalMediaLibrary/ActionsGlobalMediaLibrary";
import Actions from "../../Actions";

export default class GlobalMediaLibraryStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      uploadedAssets: [],
      uploadedLogos: [],
      companyId: null,
      companyName: null,
      isUploading: false,
      totalFiles: 0,
      uploadingCount: 0,
      oldUploadedImages: [],
      oldUploadedLogos: [],
      // Filter state
      filters: {
        contentType: "all", // "all", "templates"
        mediaType: [], // ["images", "videos"]
        ratio: [], // ["landscape", "portrait", "16:9"]
        showKPIs: true,
        showOnlyFavorites: false,
        showShutterstock: false
      }
    };

    this.pendingUploads = [];
    this.listenables = ActionsGlobalMediaLibrary;
    this.onError = this.onError.bind(this);
  }

  onError(error) {
    logger.log(
      "error:GlobalMediaLibraryStore:onError",
      "An error occurred in the Global Media Library Store:",
      error
    );
  }

  onGetCloudinaryImagesByCompanyId() {
    this.setState({
      loadingCloudinaryImages: true
    });
  }

  onGetCloudinaryImagesByCompanyIdCompleted({ payload: { images = [], logos = [], videos = [] } }) {
    logger.log("GlobalMediaLibraryStore", "onGetCloudinaryImagesByCompanyIdCompleted", {
      images,
      logos,
      videos
    });

    this.setState({
      uploadedAssets: [...images, ...videos],
      uploadedLogos: logos,
      loadingCloudinaryImages: false
    });
  }

  onGetCloudinaryImagesByCompanyIdFailed(e) {
    this.setState({ loadingCloudinaryImages: false });
    this.onError(e);
  }

  onSetCompanyId(companyId) {
    this.setState({ companyId });
  }

  onSetCompanyName(companyName) {
    this.setState({ companyName });
  }

  onNewlyUploadedImages(newImages) {
    // Map the new images to the format expected by the store
    const processedImages = newImages.map((img) => {
      return {
        image_url: img,
        source: "template-media-library",
        context: {}
      };
    });

    this.pendingUploads = [...processedImages, ...this.pendingUploads];

    const currentUploadingCount = this.state.uploadingCount;
    const newUploadingCount = currentUploadingCount - 1;

    const newState = {
      uploadingCount: newUploadingCount
    };

    this.setState(newState);

    if (newUploadingCount === 0) {
      this.onUploadComplete();
    }
  }

  onNewlyUploadedLogos(newLogos) {
    // Map the new logos to the format expected by the store
    const processedLogos = newLogos.map((logo) => {
      return {
        image_url: logo,
        source: "template-media-library",
        context: {},
        type: "logo"
      };
    });

    this.pendingUploads = [...processedLogos, ...this.pendingUploads];

    const currentUploadingCount = this.state.uploadingCount;
    const newUploadingCount = currentUploadingCount - 1;

    const newState = {
      uploadingCount: newUploadingCount
    };

    this.setState(newState);

    if (newUploadingCount === 0) {
      this.onUploadComplete();
    }
  }

  onStartUpload(totalFiles) {
    logger.log("GlobalMediaLibraryStore", "onStartUpload", { totalFiles });
    this.pendingUploads = [];

    this.setState({
      isUploading: true,
      totalFiles,
      uploadingCount: totalFiles
    });
  }

  onUploadComplete() {
    logger.log("GlobalMediaLibraryStore", "onUploadComplete");

    Actions.addNotification(
      `${this.state.totalFiles} file${this.state.totalFiles > 1 ? "s" : ""} uploaded successfully!`
    );

    // Separate logos from regular assets
    const logos = this.pendingUploads.filter((asset) => asset.type === "logo");
    const regularAssets = this.pendingUploads.filter((asset) => asset.type !== "logo");

    this.setState({
      uploadedAssets: [...regularAssets, ...this.state.uploadedAssets],
      uploadedLogos: [...logos, ...this.state.uploadedLogos],
      isUploading: false,
      totalFiles: 0,
      uploadingCount: 0
    });

    this.pendingUploads = [];
  }

  onGetOldUploadedImagesCompleted(oldImages) {
    this.setState({
      oldUploadedImages: oldImages
    });
  }

  onGetOldUploadedLogosCompleted(oldLogos) {
    this.setState({
      oldUploadedLogos: oldLogos
    });
  }

  // Filter handlers
  onSetFilter({ filterType, value }) {
    logger.log("GlobalMediaLibraryStore", "onSetFilter", { filterType, value });

    this.setState({
      filters: {
        ...this.state.filters,
        [filterType]: value
      }
    });
  }

  onToggleFilter({ filterType, value }) {
    logger.log("GlobalMediaLibraryStore", "onToggleFilter", { filterType, value });

    const currentFilters = this.state.filters[filterType] || [];
    let newFilters;

    if (Array.isArray(currentFilters)) {
      // For array-based filters (mediaType, ratio)
      if (currentFilters.includes(value)) {
        newFilters = currentFilters.filter((filter) => filter !== value);
      } else {
        newFilters = [...currentFilters, value];
      }
    } else {
      // For single value filters (contentType, showKPIs)
      newFilters =
        currentFilters === value ? (filterType === "showKPIs" ? !currentFilters : "all") : value;
    }

    this.setState({
      filters: {
        ...this.state.filters,
        [filterType]: newFilters
      }
    });
  }

  onSetShowKPIs(showKPIs) {
    this.setState({
      filters: {
        ...this.state.filters,
        showKPIs
      }
    });
  }

  onSetShowOnlyFavorites(showOnlyFavorites) {
    this.setState({
      filters: {
        ...this.state.filters,
        showOnlyFavorites
      }
    });
  }

  onSetShowShutterstock(showShutterstock) {
    this.setState({
      filters: {
        ...this.state.filters,
        showShutterstock
      }
    });
  }

  onClearFilters() {
    logger.log("GlobalMediaLibraryStore", "onClearFilters");

    this.setState({
      filters: {
        contentType: "all",
        mediaType: [],
        ratio: [],
        showKPIs: true,
        showOnlyFavorites: false,
        showShutterstock: false
      }
    });
  }

  onLikeCloudinaryAsset({ assetPublicId, type, isLiked }) {
    const updatedAssets = this.state.uploadedAssets.map((asset) => {
      if (asset.name === assetPublicId) {
        return { ...asset, isLiked };
      }
      return asset;
    });
    this.setState({ uploadedAssets: updatedAssets });
  }
}
